import React from 'react';
import { Tag, Tooltip } from 'antd';
import { calculateUserLevel } from '@/utils/level';

interface LevelBadgeProps {
  totalRecharge: number;
  size?: 'small' | 'default';
}

// 等级徽章配置 - 与徽章说明弹窗中的描述完全一致
const LEVEL_CONFIG: Record<number, {
  name: string;
  iconColor: string;
  strokeColor: string;
  description: string;
}> = {
  1: {
    name: '产品助理',
    iconColor: '#f0fdf4',
    strokeColor: '#22c55e',
    description: '起点 - 种子破土而出，象征产品之路的开始，充满成长潜力',
  },
  2: {
    name: '初级产品经理',
    iconColor: '#eff6ff',
    strokeColor: '#3b82f6',
    description: '书写 - 拿起铅笔，开始书写自己的产品故事',
  },
  3: {
    name: '中级产品经理',
    iconColor: '#f5f3ff',
    strokeColor: '#8b5cf6',
    description: '创意 - 灵感闪现，用创意点亮产品方向',
  },
  4: {
    name: '高级产品经理',
    iconColor: '#fff7ed',
    strokeColor: '#f97316',
    description: '突破 - 推动产品起飞，实现突破性增长',
  },
  5: {
    name: '资深产品经理',
    iconColor: '#fef2f2',
    strokeColor: '#ef4444',
    description: '守护 - 用经验守护产品，成为团队可靠支柱',
  },
  6: {
    name: '产品专家',
    iconColor: '#f0fdfa',
    strokeColor: '#14b8a6',
    description: '专业 - 获得专业认证，成为领域专家',
  },
  7: {
    name: '产品总监',
    iconColor: '#fefce8',
    strokeColor: '#eab308',
    description: '视野 - 高瞻远瞩，用战略眼光引领方向',
  },
  8: {
    name: '首席产品官',
    iconColor: '#faf5ff',
    strokeColor: '#7c3aed',
    description: '卓越 - 如钻石般珍贵，达到职业巅峰',
  },
};

// SVG 图标组件 - 使用 public/badges 目录下的 SVG 文件
const LevelIcon: React.FC<{ level: number; size?: number }> = ({ level, size = 20 }) => {
  const svgPath = `/badges/level-${level}.svg`;
  return (
    <img
      src={svgPath}
      alt={`Level ${level}`}
      width={size}
      height={size}
      style={{ display: 'block' }}
    />
  );
};

const LevelBadge: React.FC<LevelBadgeProps> = ({ totalRecharge, size = 'small' }) => {
  const userLevel = calculateUserLevel(totalRecharge);
  const level = userLevel.level;
  const config = LEVEL_CONFIG[level];

  if (!config) return null;

  const fontSize = size === 'small' ? 12 : 14;
  const iconSize = size === 'small' ? 20 : 24;

  return (
    <Tooltip title={config.description}>
      <Tag
        bordered={false}
        style={{
          fontSize,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          padding: '2px 8px',
          backgroundColor: config.iconColor,
          border: `1px solid ${config.strokeColor}`,
          color: config.strokeColor,
          lineHeight: '20px',
          cursor: 'pointer',
        }}
      >
        <LevelIcon level={level} size={iconSize} />
        <span style={{ whiteSpace: 'nowrap' }}>{config.name}</span>
      </Tag>
    </Tooltip>
  );
};

export default LevelBadge;
